import React from 'react';

function ButtonLoader(props){
	return(
		<span className="e-btn-loader"></span>
	)
}

export default ButtonLoader;